import styled from "styled-components";
const StyledAbbr = styled.abbr`
  text-decoration: none;
`;
export default StyledAbbr;